import { Enum_Flowpages_Display } from '@graphql/generated/graphql';
import { Content, FlowPageContent, SuccessFlowPageContent } from '../types';

export const isContentFlowPage = (
    content?: Content
): content is FlowPageContent => {
    return content?.__typename === 'ComponentPagesFlowPage';
};

export const isContentSuccessFlowPage = (
    content: Content
): content is SuccessFlowPageContent => {
    return (
        isContentFlowPage(content) &&
        content.FlowPage?.Display === Enum_Flowpages_Display.Success
    );
};
